import { getFeatureEnabled } from '@gig/magic-common';
import { WindowMessenger } from '@gig/magic-betit-lib';
import { WalletExposedMethods, WalletRegisterableMethods } from './interface/methods.js';
import { magic } from '@gig/magic-sdk';
import { Feature } from '@gig/magic-messages';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const SOURCE = "Superlenny";
class WalletService {
  constructor() {
    this.messenger = null;
    this.messengerPromise = new Promise((resolve) => {
      this.messengerResolver = resolve;
    });
  }
  getWalletUrl(paymentsPath, _a) {
    return __async(this, null, function* () {
      var _b = _a, {
        allowedBonusesList,
        disallowedWithdrawalCardTypes,
        predefinedAmounts
      } = _b, restParams = __objRest(_b, [
        "allowedBonusesList",
        "disallowedWithdrawalCardTypes",
        "predefinedAmounts"
      ]);
      const predefinedAmountOptions = Object.keys(predefinedAmounts || {}).reduce((acc, key) => {
        acc[`predefined${key}Amounts`] = this.normalizeListOption(predefinedAmounts[key]) || "";
        return acc;
      }, {});
      const [
        methodRemovalEnabled,
        depositRemainingLimitsEnabled,
        bonusCodeCashierEnabled,
        disableWithdrawalReverse,
        showShopSelectionScreen
      ] = yield Promise.all([
        getFeatureEnabled(Feature.WALLET_METHOD_REMOVAL),
        getFeatureEnabled(Feature.REMAINING_DEPOSIT_LIMIT_AMOUNT),
        getFeatureEnabled(Feature.BONUS_CODE_CASHIER),
        getFeatureEnabled(Feature.DISABLE_WITHDRAWAL_REVERSE),
        getFeatureEnabled(Feature.SHOW_SHOP_SELECTION_SCREEN)
      ]);
      const normalizedParameters = __spreadProps(__spreadValues(__spreadValues({}, restParams), predefinedAmountOptions), {
        allowedBonusesList: this.normalizeListOption(allowedBonusesList),
        disallowedWithdrawalCardTypes: this.normalizeListOption(disallowedWithdrawalCardTypes),
        useMemoryRouter: true,
        methodRemovalEnabled,
        depositRemainingLimitsEnabled,
        bonusCodeCashierEnabled,
        disableWithdrawalReverse,
        showShopSelectionScreen
      });
      this.lastSetView = restParams.view;
      const queryParams = Object.entries(normalizedParameters).map(([key, value]) => {
        if (!value) {
          return "";
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
      }).join("&");
      return `${paymentsPath}?${queryParams}`;
    });
  }
  createMessenger(frame, paymentsPath) {
    var _a;
    this.messenger = new WindowMessenger(frame, paymentsPath, SOURCE, SOURCE);
    (_a = this.messengerResolver) == null ? void 0 : _a.call(this);
  }
  destroy() {
    if (this.messenger) {
      this.messenger.destroy();
    }
    this.messenger = null;
  }
  goToHomeView() {
    this.getMessenger().send(WalletExposedMethods.GO_TO_HOME_VIEW);
  }
  goToPreviousView() {
    this.getMessenger().send(WalletExposedMethods.GO_TO_PREVIOUS_VIEW);
  }
  setDepositMethod(method) {
    this.getMessenger().send(WalletExposedMethods.SET_DEPOSIT_METHOD, method);
  }
  setWithdrawalMethod(method) {
    this.getMessenger().send(WalletExposedMethods.SET_WITHDRAWAL_METHOD, method);
  }
  setLanguageCode(code) {
    this.getMessenger().send(WalletExposedMethods.SET_LANGUAGE_CODE, code);
  }
  setView(view) {
    if (this.hasMessenger()) {
      this.lastSetView = view;
      this.getMessenger().send(WalletExposedMethods.SET_VIEW, view);
    } else {
      this.getMessengerAsync().then(() => {
        this.lastSetView = view;
        this.getMessenger().send(WalletExposedMethods.SET_VIEW, view);
      });
    }
  }
  getLastSetView() {
    return this.lastSetView;
  }
  setTheme(theme) {
    this.getMessenger().send(WalletExposedMethods.SET_THEME, theme);
  }
  updateTranslations(translationsUrl) {
    this.getMessenger().send(WalletExposedMethods.UPDATE_TRANSLATIONS, translationsUrl);
  }
  resumeDeposit(quickDeposit) {
    this.getMessenger().send(WalletExposedMethods.RESUME_DEPOSIT, quickDeposit);
  }
  onEvent(handler) {
    this.getMessenger().register(WalletRegisterableMethods.ON_EVENT, ({ params }) => handler(params));
  }
  init() {
    const messenger = this.getMessenger();
    messenger.init();
    messenger.register(WalletRegisterableMethods.GET_BONUSES, (event, callback) => __async(this, null, function* () {
      try {
        const bonuses = yield magic.methods.wallet.getApplicableBonuses();
        callback(bonuses);
      } catch (e) {
        console.error("Wallet Error", e);
        callback([]);
      }
    }));
    messenger.register(WalletRegisterableMethods.GET_REMAINING_DEPOSIT_LIMITS, (event, callback) => __async(this, null, function* () {
      const enabled = yield getFeatureEnabled(Feature.REMAINING_DEPOSIT_LIMIT_AMOUNT);
      if (!enabled) {
        return callback(0);
      }
      try {
        const response = yield magic.methods.wallet.getDepositRemainingLimits();
        const limits = response.limitResults.map((limit2) => limit2.remaining);
        const limit = limits.length ? Math.min(...limits) : 0;
        callback(limit);
      } catch (e) {
        console.error("Wallet Error", e);
        callback(0);
      }
    }));
  }
  goToGames(callback) {
    const messenger = this.getMessenger();
    messenger.register(WalletRegisterableMethods.GO_TO_GAMES, callback);
  }
  hasMessenger() {
    return !!this.messenger;
  }
  getMessenger() {
    if (!this.messenger) {
      throw new Error("Message communication channel has not been initialized yet");
    }
    return this.messenger;
  }
  getMessengerAsync() {
    return __async(this, null, function* () {
      yield this.messengerPromise;
      return this.messenger;
    });
  }
  normalizeListOption(values) {
    if (!values) {
      return void 0;
    }
    return values.join(",");
  }
}
const wallet = new WalletService();

export { WalletService, wallet };
